import { CreationDataOrigin } from './../dossier';

export interface Supervisor {
  email: string;
  env: string[];
  origin?: CreationDataOrigin[];
}
